import React, { useState, useEffect } from 'react';
import {
  LayoutDashboard,
  FileText,
  Users,
  Mail,
  Download,
  Info,
  Award,
  Clock,
  CheckCircle,
  AlertCircle,
  Eye,
  Calendar,
  ChevronRight,
  Activity,
  Hash,
  Phone,
  MapPin,
  MessageSquare,
  User,
  Type
} from 'lucide-react';
import './AdminDashboard.css';
import { ApiUrl } from '../API/ApiUrl';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useQueries } from "@tanstack/react-query";

const AdminDashboard = () => {

  const navigate = useNavigate();



  const fetchDashboard = async () => {
    const token = localStorage.getItem("adminToken");

    const res = await fetch(`${ApiUrl}/dashboard`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error("Failed to fetch dashboard");
    }

    return data;
  };

  const fetchDownloads = async () => {
    const res = await fetch(`${ApiUrl}/downloads`);
    const data = await res.json();

    if (!res.ok) {
      throw new Error("Failed to fetch downloads");
    }

    return data || [];
  };

  const fetchTotalDownloads = async () => {
    const token = localStorage.getItem("adminToken");

    const res = await fetch(`${ApiUrl}/downloads/total`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error("Failed to fetch total downloads");
    }

    return data.total_downloads || 0;
  };

  const results = useQueries({

    queries: [
      {
        queryKey: ["dashboard"],
        queryFn: fetchDashboard,
        staleTime: 5 * 60 * 1000,
      },
      {
        queryKey: ["downloads"],
        queryFn: fetchDownloads,
        staleTime: 5 * 60 * 1000,
      },
      {
        queryKey: ["totalDownloads"],
        queryFn: fetchTotalDownloads,
        staleTime: 5 * 60 * 1000,
      },
    ],
  });



  const dashboardData = results[0].data || {};
  const downloads = results[1].data || [];
  const totalDownloads = results[2].data || 0;

  // destructure dashboard
  const onlineSubmissions = dashboardData.onlineSubmissions || {};
  const reviewerSubmissions = dashboardData.reviewerSubmissions || {};
  const editorialBoard = dashboardData.editorialBoard || {};
  const contacts = dashboardData.contactMessages || {};
  const profile = dashboardData.profile || {};

// if (results.some(q => q.isLoading)) return null;

  return (
    <div className="dashboard-page">
      {/* Header */}
      {/* <div className="page-header">
        <div className="header-left">
          <div className="header-icon">
          <LayoutDashboard size={24} />
          </div>
          <div>
            <h1 className="page-title">Journal Dashboard</h1>
            <p className="page-subtitle">Welcome back, Dr. Chen. Here's your journal overview</p>
          </div>
        </div>
      </div> */}
      <div className="page-header">
        <div className="title-section">
          <LayoutDashboard size={40} className="title-icon" />
          <div>
            <h1 className="page-title">Journal Dashboard</h1>
            <p className="page-subtitle">{`Welcome back, Mr. ${profile?.name || "Admin"} `}</p>
          </div>
        </div>


      </div>
      <div className="quick-stats-grid">
        <div className="stat-card" onClick={() => navigate("/admin/online-submissions")}>
          <div className="stat-icon" style={{ background: '#eff6ff' }}>
            <FileText size={20} style={{ color: '#3b82f6' }} />
          </div>
          <div className="stat-content">
            <span className="stat-label">Online Submissions</span>
            <span className="stat-value">{onlineSubmissions.total}</span>
            {/* <span className="stat-detail">+12 this week</span> */}
          </div>
        </div>

        <div className="stat-card" onClick={() => navigate("/admin/reviewer-submissions")}>
          <div className="stat-icon" style={{ background: '#e6f7f0' }}>
            <Users size={20} style={{ color: '#10b981' }} />
          </div>
          <div className="stat-content">
            <span className="stat-label">Reviewer Submissions</span>
            <span className="stat-value">{reviewerSubmissions.total}</span>
            {/* <span className="stat-detail">{reviewerSubmissions.pending} pending</span> */}
          </div>
        </div>

        <div className="stat-card" onClick={() => navigate("/admin/editorial-board")}>
          <div className="stat-icon" style={{ background: '#fef3c7' }}>
            <Award size={20} style={{ color: '#f59e0b' }} />
          </div>
          <div className="stat-content">
            <span className="stat-label">Editorial Board</span>
            <span className="stat-value">{editorialBoard.total}</span>
            {/* <span className="stat-detail">{editorialBoard.editorInChief} EIC</span> */}
          </div>
        </div>

        <div className="stat-card" onClick={() => navigate("/admin/contacts")}>
          <div className="stat-icon" style={{ background: '#fee2e2' }}>
            <Mail size={20} style={{ color: '#ef4444' }} />
          </div>
          <div className="stat-content">
            <span className="stat-label">Contacts</span>
            <span className="stat-value">{contacts.total}</span>
            {/* <span className="stat-detail">{contacts.is_read} unread</span> */}
          </div>
        </div>

        <div className="stat-card" onClick={() => navigate("/admin/downloads")}>
          <div className="stat-icon" style={{ background: '#f3e8ff' }}>
            <Download size={20} style={{ color: '#8b5cf6' }} />
          </div>
          <div className="stat-content">
            <span className="stat-label">Downloads</span>
            <span className="stat-value">{totalDownloads}</span>
            {/* <span className="stat-detail">Total downloads</span> */}
          </div>
        </div>

        {/* <div className="stat-card">
          <div className="stat-icon" style={{ background: '#ffe2e6' }}>
            <Info size={20} style={{ color: '#ec4899' }} />
          </div>
          <div className="stat-content">
            <span className="stat-label">General Info</span>
            <span className="stat-value">{generalInfo.issn}</span>
            <span className="stat-detail">{generalInfo.frequency}</span>
          </div>
        </div> */}
      </div>

      {/* Main Dashboard Grid */}
      <div className="dashboard-grid">
        {/* Left Column - Online Submissions */}
        <div className="grid-column">
          <div className="dashboard-card">
            <div className="card-header">
              <h3>Recent Online Submissions</h3>
              <Link to={"/admin/online-submissions"} className='link'>

                <button className="view-all">
                  <span>View All</span>
                  <ChevronRight size={14} />
                </button>
              </Link>
            </div>
            <div className="submissions-list">
              {onlineSubmissions?.recent?.map((submission, idx) => (
                <div key={submission.id} className="submission-item">
                  <div className="submission-info">
                    <h4>{submission.paper_title}</h4>

                    <div className="submission-meta">
                      <span className="meta-item">
                        <Hash size={10} />
                        {idx + 1}
                      </span>

                      <span className="meta-item">
                        <Type size={10} />
                        {submission.paper_type}
                      </span>
                    </div>

                    <div className="meta-item">
                      Author: {submission.corresponding_author_name}
                    </div>
                  </div>

                  <div className="submission-date">
                    <Calendar size={10} />
                    <span>
                      {new Date(submission.created_at).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric"
                      })}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* <div className="dashboard-card">
            <div className="card-header">
              <h3>Submission Types</h3>
            </div>
            <div className="type-stats">
              <div className="type-item">
                <span className="type-name">Research Articles</span>
                <span className="type-count">{onlineSubmissions.researchArticles}</span>
              </div>
              <div className="type-item">
                <span className="type-name">Review Papers</span>
                <span className="type-count">{onlineSubmissions.reviewPapers}</span>
              </div>
              <div className="type-item">
                <span className="type-name">Case Studies</span>
                <span className="type-count">{onlineSubmissions.caseStudies}</span>
              </div>
            </div>
          </div> */}


          <div className="dashboard-card">
            <div className="card-header">
              <h3>Download Statistics</h3>
            </div>
            <div className="download-stats">
              {downloads.map((item, index) => (
                <div key={index} className="download-item">
                  <span className="download-type">{item.type_name}</span>
                  <span className="download-count">{item.download_count}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Middle Column - Reviewer & Editorial */}
        <div className="grid-column">
          <div className="dashboard-card">
            <div className="card-header">
              <h3>Recent Reviewer Applications</h3>
              <Link to={"/admin/reviewer-submissions"} className='link'>

                <button className="view-all">
                  <span>View All</span>
                  <ChevronRight size={14} />
                </button>
              </Link>
            </div>
            <div className="reviewers-list">
              {reviewerSubmissions?.recent?.map((reviewer) => (
                <div key={reviewer.id} className="reviewer-item">
                  <div className="reviewer-info">

                    <span className="reviewer-name">
                      <User size={12} />
                      {reviewer.full_name}
                    </span>

                    <span className="reviewer-qualification">
                      {reviewer.qualification}
                    </span>

                    <span className="reviewer-phone">
                      <Phone size={10} />
                      {reviewer.contact_number}
                    </span>

                  </div>

                  <span className="reviewer-date">
                    {new Date(reviewer.created_at).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric"
                    })}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="grid-column">
            <div className="dashboard-card">
              <div className="card-header">
                <h3>Recent Contact Messages</h3>
                <Link to={"/admin/contacts"} className='link'>
                  <button className="view-all">
                    <span>View All</span>
                    <ChevronRight size={14} />
                  </button></Link>
              </div>
              <div className="contacts-list">
                {contacts?.recent?.map((contact) => (
                  <div key={contact.id} className="contact-item">
                    <div className="contact-info">
                      <span className="contact-name">
                        <User size={12} />
                        {contact.name}
                      </span>
                      <span className="contact-email">{contact.email}</span>
                      <span className="contact-subject">
                        <MessageSquare size={10} />
                        {contact.subject}
                      </span>
                      <span className="contact-message-preview">
                        {contact.message}
                      </span>
                    </div>
                    <span className="contact-date">{new Date(contact.created_at).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric"
                    })}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* <div className="dashboard-card">
            <div className="card-header">
              <h3>Recent Activity</h3>
              <Activity size={16} className="card-icon" />
            </div>
            <div className="activity-list">
              {recentActivities.map((activity) => (
                <div key={activity.id} className="activity-item">
                  <div className={`activity-dot ${activity.type}`}></div>
                  <div className="activity-content">
                    <p className="activity-text">{activity.description}</p>
                    <p className="activity-target">{activity.item}</p>
                    <span className="activity-time">{activity.time}</span>
                  </div>
                </div>
              ))}
            </div>
          </div> */}


          </div>
        </div>

        {/* Right Column - Contacts & Activity */}

        <div className="dashboard-card">
          <div className="card-header">
            <h3>Editorial Board Overview</h3>
            <Link to={"/admin/editorial-board"} className='link'>

              <button className="view-all">
                <span>View All</span>
                <ChevronRight size={14} />
              </button>
            </Link>
          </div>
          <div className="board-list">
            {editorialBoard?.recent?.map((member) => (
              <div key={member.id} className="board-item">
                <div className="board-info">

                  <span className="board-name">
                    {member.name}
                  </span>

                  <span className="board-type">
                    {member.editor_type}
                  </span>

                  <span className="board-location">
                    <MapPin size={10} />
                    {member.location}
                  </span>

                </div>

                <span className="board-email">
                  {member.email}
                </span>
              </div>
            ))}
          </div>
        </div>

      </div>

      {/* Footer Stats */}
      {/* <div className="dashboard-footer">
        <div className="footer-stat">
          <Info size={14} />
          <span>ISSN: {generalInfo.issn}</span>
        </div>
        <div className="footer-stat">
          <Clock size={14} />
          <span>Frequency: {generalInfo.frequency}</span>
        </div>
        <div className="footer-stat">
          <Mail size={14} />
          <span>Contact: {generalInfo.email}</span>
        </div>
        <div className="footer-stat">
          <CheckCircle size={14} />
          <span>Active Reviewers: {reviewerSubmissions.active}</span>
        </div>
        <div className="footer-stat">
          <Users size={14} />
          <span>Board Members: {editorialBoard.total}</span>
        </div>
      </div> */}
    </div>
  );
};

export default AdminDashboard;